export function getContractAbiRequest(name) {
  if (name === 'TokenLocker') {
    return {
      url: `/api/v1.0/tokenlocker/contracts/abi/${name}`
    }
  }

  return {
    url: `/api/contracts/abi`,
    params: { name }
  }
}
